// extracted by mini-css-extract-plugin
export var caption = "Activity-module--caption--73cf7";
export var container = "Activity-module--container--1bf63";
export var image = "Activity-module--image--60b9f";
export var overlay = "Activity-module--overlay--8e5b3";